export default "__VITE_ASSET__bcf76be5__"